import { render } from "./Currency.vue?vue&type=template&id=67734cf8&scoped=true"
import script from "./Currency.vue?vue&type=script&lang=ts"
export * from "./Currency.vue?vue&type=script&lang=ts"

import "./Currency.vue?vue&type=style&index=0&id=67734cf8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-67734cf8"

export default script